import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationPauseContinuousOptimizationCampaignSegmentArgs,
  BackendSegment,
} from 'src/types/backend';

const MUTATION = gql`
  mutation PauseSegmentCampaign($campaignId: ID!, $segmentId: ID!) {
    pauseContinuousOptimizationCampaignSegment(campaignId: $campaignId, segmentId: $segmentId) {
      id
      status
    }
  }
`;

type Variables = BackendMutationPauseContinuousOptimizationCampaignSegmentArgs;
type Result = Pick<BackendSegment, 'id' | 'status'>;

export const pauseSegmentCampaign = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
